<div class="room-settings__wrapper">
  <h3>{{ '+INSTALLATIONS.INSTALLATION.REFERENCE_ROOM.ASSIGN_ROOM.HEADER' | translate }}</h3>

  <p class="mt-[16px] mb-[8px]">
    {{ '+INSTALLATIONS.INSTALLATION.REFERENCE_ROOM.ASSIGN_ROOM.DESCRIPTION' | translate }}
  </p>

  <div class="active-room-list" *ngIf="rooms$ | async">
    <div *ngFor="let room of updatedRoomsData" class="room-settings__room-entry">
      <div class="room-settings__room-details">
        <p>{{ room.name }}</p>
        <mat-icon
          class="text-[20px] pl-[8px]"
          [matTooltip]="
            '+INSTALLATIONS.INSTALLATION.REFERENCE_ROOM.ASSIGN_ROOM.HC_FIXED_INFO' | translate
          "
          *ngIf="!room.isSelectable"
          >info_outline</mat-icon
        >
      </div>

      <mat-slide-toggle
        gtm="onToggle"
        gtmAction="Turn feature on off"
        gtmCategory="Manage features"
        [checked]="room.isSelected"
        [disabled]="!room.isSelectable"
        (change)="updateRoomStatus(room.featureRoomId)"
      >
      </mat-slide-toggle>
    </div>
  </div>

  <div class="w-full flex justify-end">
    <button
      class="mt-[24px]"
      mat-stroked-button
      gtm="onSelect"
      gtmAction="Go to reference room assignment"
      gtmCategory="installationDetails"
      (click)="saveChanges()"
    >
      {{ 'GENERAL.BUTTON.SAVE' | translate }}
    </button>
  </div>
</div>
